import { createSlice } from '@reduxjs/toolkit';
import getConfig from 'next/config';
import { Sentry } from 'root/utils/raven';
import apiClient from '../../lib/apiClient';

const { publicRuntimeConfig = {} } = getConfig ? getConfig() : {};

const initialState = {
  items: [],
  isLoading: false,
  error: null,
};

const bookmarksSlice = createSlice({
  name: 'bookmarks',
  initialState,
  reducers: {
    getBookmarkStart(state) {
      state.isLoading = true;
    },
    getBookmarkSuccess(state, { payload: { data } }) {
      state.items = data;
      state.isLoading = false;
      state.error = null;
    },
    getBookmarkFailure(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

export const {
  getBookmarkStart,
  getBookmarkSuccess,
  getBookmarkFailure,
} = bookmarksSlice.actions;

export default bookmarksSlice.reducer;

export const fetchBookmark = (postsPerPage = 9, page = 1, orderby = 'title', order = 'desc') => async (dispatch) => {
  try {
    dispatch(getBookmarkStart());
    const content = await apiClient(
      {
        baseURL: publicRuntimeConfig.BASE_API_URL,
        method: 'GET',
        url: `/bookmarks/posts?per_page=${postsPerPage}&page=${page}&orderby=${orderby}&order=${order}`,
      });
    dispatch(getBookmarkSuccess({
      data: content,
    }));
  } catch (e) {
    dispatch(getBookmarkFailure(e.toString()));
    Sentry.captureException(e.toString());
  }
};

export const getBookmarkById = async (id) => {
  try {
    const content = await apiClient(
      {
        baseURL: publicRuntimeConfig.BASE_API_URL,
        method: 'GET',
        url: `/bookmarks/posts/${id}`,
      });
    return content;
  } catch (e) {
    Sentry.captureException(e.toString());
    return null;
  }
};

export const addBookmark = (bookmark) => async (dispatch, getState) => {
  try {
    const { items } = getState().bookmarks;
    await apiClient(
      {
        baseURL: publicRuntimeConfig.BASE_API_URL,
        method: 'POST',
        url: '/bookmarks/posts',
        data: bookmark
      });

    const newBookmark = await getBookmarkById(bookmark.id);
    if (newBookmark) {
      const data = [...items, newBookmark];
      dispatch(getBookmarkSuccess({
        data,
      }));
    }
  } catch (e) {
    Sentry.captureException(e.toString());
  }
};

export const deleteBookmark = (id) => async (dispatch, getState) => {
  try {
    dispatch(getBookmarkStart());
    const { items } = getState().bookmarks;
    await apiClient(
      {
        baseURL: publicRuntimeConfig.BASE_API_URL,
        method: 'DELETE',
        url: `/bookmarks/posts/${id}`
      });

    const newItems = items.filter((item) => (item.id !== id));
    dispatch(getBookmarkSuccess({
      data: newItems
    }));
  } catch (e) {
    Sentry.captureException(e.toString());
  }
};

export const setBookmark = ({ data }) => getBookmarkSuccess({
  data,
});
